<script lang="ts">
	import { thumbor } from '$lib/serv/image-details';
	import type { ImageDetails } from 'proto/image';
	import PnPLogoLight from '../shared/icons/PnPLogoLight.svelte';

	export let logo: ImageDetails = {provider: '', base_url: '', filename: '', raw_image: '', mime_type: ''};
	export let name: string;
	export let estimate: string = ''; 
	export let closing: string = ''; // The grey text in the UI
	export let vertical = 'restaurant';

</script>

<article class="sidenav-header">
	{#if logo}
		{@const lg = thumbor(logo, 200)}
		<div class="logo">
			{#if vertical === 'restaurant'}
				<img src={lg} alt={name}>
			{:else}
				<PnPLogoLight/>
			{/if}
		</div>
	{/if}
	<div class="info">
		<!-- (Brand link moved to the bottom of the restaurant SEO page) -->
		<h4 class="headline-s bold">{name}</h4>
		<p class="label-m bold">{estimate}</p>
		<span class="label-m grey">{closing}</span>
		{#if $$slots.default}
			<slot />
		{/if}
		<!-- {#if vertical !== 'restaurant'}
			<button class="label-m" on:click={handleAddressModalState}>Change store</button>
		{/if} -->
	</div>
</article>

<style lang="scss">
	@use 'color';

	.sidenav-header {
		display: flex;
		.logo {
			min-width: 52px;
			width: 52px;
			height: 52px;
			padding: 4px;
			border: 1px solid color.$separator;
			border-radius: 15px;
			background: color.$white;
			display: flex;
			justify-content: center;
			box-shadow: 0 0 45px -10px color.$on-background-low-importance;
			img, svg {
				display: block;
				height: 100%;
				margin: 0 auto;
			}
		}
		.info {
			padding-left: 1rem;
			h4 {
				font-size: 1.3rem;
				line-height: 1.6rem;
				margin-bottom: .25rem;
				word-break: break-word;
			}
			p { margin: .25rem 0; }
			:global(button) {
				text-decoration: underline;
				cursor: pointer;
			}
		}
	}
</style>